// extracted by mini-css-extract-plugin
module.exports = {"tableStyle":"SlabCommission-module--tableStyle--1IIh3","range":"SlabCommission-module--range--1oQC1"};